/** Created by azhou on 2019/3/11.*/
<template>
  <ul class="list-item">
    <li class="w-30 list-item-col flex-column">
      <span class="text-info" v-if="userInfo.type!==2">{{Itemize.tid | formatVar('EXPTYPES')}}</span>
      <label v-else>{{Itemize.storeName}}
        <el-popover placement="right" trigger="hover">
          {{Itemize.order_no}}
          <span class="text-info" slot="reference"><i class="el-icon-info text-info"></i></span>
        </el-popover>
      </label>
    </li>
    <li class="w-10 list-item-col" v-if="userInfo.type===2" :class="$GFUN.userColor(Itemize.storeType)">
      <div v-if="Itemize.storeType == 7">度假产品</div>
      <div v-else>{{Itemize.storeType | formatVar('StoreType')}}</div>
    </li>
    <li class="w-15 list-item-col" v-if="userInfo.type===2">{{Itemize.type}}</li>
    <li class="w-20 list-item-col">&yen; {{Itemize.money / 100 | formatMoney}} 元</li>
    <li class="w-10 list-item-col" v-if="userInfo.type===2">{{Itemize.channelType | formatVar('payChannel')}}</li>
    <li class="w-15 list-item-col">
      <span v-if="search == 'checkinout'">{{Itemize.date_in | formatTimestamp(1)}}</span>
      <span v-else>{{Itemize.adtime | formatTimestamp(1)}}</span>
    </li>
    <li class="w-30 list-item-col">{{Itemize.trade_no}}</li>
    <li class="w-10 list-item-col-end">{{Itemize.remark || '暂无说明'}}</li>
  </ul>
</template>

<script>
import {mapGetters} from 'vuex'
  export default {
    name: 'ItemizeMoney',
    props:{
      Itemize:{},
      search: ''
    },
    computed:{
      ...mapGetters(['userInfo'])
    }
  }
</script>
